import { render, staticRenderFns } from "./BaseSlotMessage.vue?vue&type=template&id=961da56a&"
import script from "./BaseSlotMessage.vue?vue&type=script&lang=js&"
export * from "./BaseSlotMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('961da56a')) {
      api.createRecord('961da56a', component.options)
    } else {
      api.reload('961da56a', component.options)
    }
    module.hot.accept("./BaseSlotMessage.vue?vue&type=template&id=961da56a&", function () {
      api.rerender('961da56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseSlotMessage.vue"
export default component.exports